import cls from '@utils/css-select';
import React, { forwardRef, Ref, useEffect, useImperativeHandle, useRef, useState } from 'react';
import styles from "./styles.scss";

type AcMarqueeProps = {
	children: React.ReactNode;
	order: 'asc' | 'desc';
}
const cx = cls(styles)
let timerMarquee: number;
function AcMarquee(props: AcMarqueeProps, ref: Ref<any>) {
	const { children, order, ...rest } = props;
	const domMiRef = useRef<any>(null)
	const domMwRef = useRef<any>(null)

	function landscapeMarquee() {
		if (order === 'asc') {
			domMwRef.current.scrollLeft >= domMiRef.current.scrollWidth ? domMwRef.current.scrollLeft = 0 : domMwRef.current.scrollLeft++;
		} else {
			domMwRef.current.scrollLeft <= 0 ? domMwRef.current.scrollLeft = domMiRef.current.scrollWidth : domMwRef.current.scrollLeft--;
		}
		timerMarquee = requestAnimationFrame(landscapeMarquee);
	}

	function cancelTimerMarquee() {
		domMwRef.current = null
		cancelAnimationFrame(timerMarquee)
	}

	useEffect(() => {
		if (domMwRef.current) {
			landscapeMarquee()
		}
		return () => {
			cancelTimerMarquee()
		}
	}, [])

	useImperativeHandle(ref, () => ({
		cancelTimerMarquee
	}))

	return (
		<div className={cx('ac-marquee')} >
			<div className={cx('marquee-wrap')} ref={domMwRef}>
				<div className={cx('marquee-item')} ref={domMiRef}>
					{children}
				</div>
				<div className={cx('marquee-item')}>
					{children}
				</div>
			</div>
		</div>
	)
}

export default forwardRef(AcMarquee)
